import mergeModuleConfigs from 'core/utils/mergeModuleConfigs';
import { stickyFooterVendor as orgConfig } from 'org/configs/modules.config';

const defaultConfig = {
  defaults: {
    stickyFooterButton: {
      buttonImage: null,
      buttonCTA: 'Get the button',
    },
    stickyFooterEmail: {
      emailImage: null,
      emailCTA: 'Subscribe to email',
      emailCongratualationsImage: null,
      emailCongratualationsCTA: 'Subscribed to email',
      subscribeOnEmailsOptions: {
        formName: 'EmailPopup',
        endPoint: 'auth.php',
        emailOptions: {
          email_news_optin: 1,
          email_odotw_optin: 1,
          email_promo_optin: 1,
          email_global_optout: 0,
        },
      },
      subscribeOnFavoritesOptions: {
        formName: 'UpdateFavoriteAlerts',
        endPoint: 'auth.php',
        emailOptions: { email_favorites_optin: 1 },
      },
    },
  },
};

export default mergeModuleConfigs(defaultConfig, orgConfig);
